import { Button, Col, Row } from 'antd';
import { ProductOutput } from 'gql/types';
import { TableSearchInput } from 'modules/common/components';
import { useDebounce } from 'modules/common/hooks';
import PrintProductLabels from 'modules/products/components/PrintProductLabels';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  onSearch?: (value: string | undefined) => void;
  selectedProducts?: ProductOutput[];
};

const Header: FC<PropTypes> = ({ onSearch, selectedProducts }) => {
  const { t } = useTranslation('products.ProductsTable.Header');
  const { debounce, clearDebounce } = useDebounce();

  const hasSelectedRows = Boolean(selectedProducts?.length);

  const handleSearch = (value: string) => {
    onSearch?.(value);
  };

  useEffect(() => {
    return clearDebounce;
  }, []);

  return (
    <Row gutter={[10, 0]}>
      <Col flex={1}>
        <TableSearchInput
          paramKeys={['searchQuery']}
          onSearchChange={debounce(handleSearch)}
          placeholder={t('searchProduct')}
          maxLength={100}
        />
      </Col>
      {hasSelectedRows && (
        <Col>
          <PrintProductLabels products={selectedProducts}>
            <Button block type="primary">
              {t('print')}
            </Button>
          </PrintProductLabels>
        </Col>
      )}
    </Row>
  );
};

export default Header;
